import { create } from 'zustand'

interface GameState {
  isPlaying: boolean
  isPaused: boolean
  score: number
  kills: number
  health: number
  ammo: number
  maxAmmo: number
  weapons: string[]
  currentWeapon: string
  position: { x: number; y: number; z: number }
  zoneRadius: number
  zoneCenter: { x: number; z: number }
  timeRemaining: number
  
  startGame: () => void
  pauseGame: () => void
  resumeGame: () => void
  endGame: () => void
  updateScore: (points: number) => void
  addKill: () => void
  takeDamage: (amount: number) => void
  heal: (amount: number) => void
  setAmmo: (amount: number) => void
  setWeapon: (weapon: string) => void
  setPosition: (pos: { x: number; y: number; z: number }) => void
  updateZone: (radius: number, center: { x: number; z: number }) => void
  setTimeRemaining: (time: number) => void
}

export const useGameStore = create<GameState>((set) => ({
  isPlaying: false,
  isPaused: false,
  score: 0,
  kills: 0,
  health: 100,
  ammo: 30,
  maxAmmo: 30,
  weapons: ['pistol'],
  currentWeapon: 'pistol',
  position: { x: 0, y: 0, z: 0 },
  zoneRadius: 500,
  zoneCenter: { x: 0, z: 0 },
  timeRemaining: 600,

  startGame: () => set({
    isPlaying: true,
    isPaused: false,
    score: 0,
    kills: 0,
    health: 100,
    ammo: 30,
    weapons: ['pistol'],
    currentWeapon: 'pistol',
    position: { x: 0, y: 50, z: 0 },
    zoneRadius: 500,
    zoneCenter: { x: 0, z: 0 },
    timeRemaining: 600,
  }),

  pauseGame: () => set({ isPaused: true }),
  resumeGame: () => set({ isPaused: false }),
  endGame: () => set({ isPlaying: false, isPaused: false }),

  updateScore: (points) => set((s) => ({ score: s.score + points })),
  addKill: () => set((s) => ({ kills: s.kills + 1, score: s.score + 100 })),
  takeDamage: (amount) => set((s) => ({ health: Math.max(0, s.health - amount) })),
  heal: (amount) => set((s) => ({ health: Math.min(100, s.health + amount) })),
  setAmmo: (amount) => set((s) => ({ ammo: Math.min(s.maxAmmo, amount) })),
  setWeapon: (weapon) => set({ currentWeapon: weapon }),
  setPosition: (pos) => set({ position: pos }),
  updateZone: (radius, center) => set({ zoneRadius: radius, zoneCenter: center }),
  setTimeRemaining: (time) => set({ timeRemaining: time }),
}))